import { render, staticRenderFns } from "./ProjectDataMaintenance.vue?vue&type=template&id=8f2fa664&scoped=true&"
import script from "./ProjectDataMaintenance.vue?vue&type=script&lang=js&"
export * from "./ProjectDataMaintenance.vue?vue&type=script&lang=js&"
import style0 from "./ProjectDataMaintenance.vue?vue&type=style&index=0&id=8f2fa664&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f2fa664",
  null
  
)

export default component.exports